<template>
  <div class="animated fadeIn">
    <b-card border-variant="primary">
      <div slot="header">
        <strong>SignOut</strong>
        <span class="float-right">Request from {{model.created_at | sdate}}</span>
      </div>
      <b-row>
        <b-col md="6">
          <b-form-group>
            <label for="ph_company" v-b-tooltip.hover title="Company.">Partner</label>
            <h5>
              <a style="cursor:pointer;color:skyblue;" id="ph_company" v-if="model.partner" @click="$router.push({ name : 'partner', params : { id : model.group.id } })">
                {{model.partner.username}}
              </a>
            </h5>
          </b-form-group>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col md="2">
          <b-form-group>
            <label for="ph_credit" v-b-tooltip.hover title="some has comment">Credit</label>
            <b-form-input v-if="model.group" class="bg-light" type="text" id="ph_credit" :plantext="true"  v-model="model.group.credit"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group>
            <label for="ph_service" v-b-tooltip.hover title="some has comment">Service</label>
            <b-form-input v-if="model.group" class="bg-light" type="text" id="ph_service" :plantext="true"  v-model="model.group.service"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="8">
          <b-form-group>
            <label for="ph_groupname"  v-b-tooltip.hover title="Company.">Group</label>
            <h5>
              <a style="cursor:pointer;color:skyblue;" id="ph_groupname" v-if="model.group" @click="$router.push({ name : 'group', params : { id : model.group.id } })">
                {{model.group.groupname}}
              </a>
            </h5>
          </b-form-group>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col md="3">
          <b-form-group label="Compelate" label-for="ph_use" v-b-tooltip.hover title="status of sigout processing result">
            <c-switch color="info" label size="sm" v-model="model.is_del" :disabled="lock" />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Signout Approve" label-for="ph_use" v-b-tooltip.hover title="Compelate signout process">
            <c-switch color="info" label size="sm" v-model="model.is_approve" :disabled="lock" />
          </b-form-group>
          <span v-if="model.is_approve">{{model.approved_at | datetime}}</span>
        </b-col>
        <b-col md="3" v-if="model.is_approve">
          <b-form-group>
            <label for="ph_company" v-b-tooltip.hover title="Company.">Recent Using Date</label>
            <b-form-input type="text" id="ph_company" v-model="model.prev_bill_start_at" :plaintext="lock"></b-form-input>
            ~
            <b-form-input type="text" id="ph_company" v-model="model.prev_bill_end_at" :plaintext="lock"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Termination defense" label-for="ph_use" v-b-tooltip.hover title="Recovery setting for continue using">
            <c-switch color="info" label size="sm" v-model="model.is_recovery" :disabled="lock" />
          </b-form-group>
          <span v-if="model.is_recovery">{{model.recovery_at | datetime}}</span>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col md="12">
          <b-form-group>
            <label for="ph_description" v-b-tooltip.hover title="some has comment">Description</label>
            <b-form-input class="bg-light" type="text" id="ph_description" :disabled="model.is_del" v-model="model.description"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-button :disabled="model.is_del" size="sm" variant="success" @click="confirm_continue = true"> Termination defense(Continue) </b-button>
      <b-button :disabled="model.is_del" size="sm" variant="danger" @click="confirm_end = true"> End of service </b-button>
      <b-button size="sm" class="float-right" variant="primary" @click="list"> List </b-button>
    </b-card>
    <b-modal title="Service using continue"  class="modal-warning" v-model="confirm_continue" @ok="service_continue" ok-variant="warning">
      Are you sure continue using service ?
      again start charge from today, all can use
    </b-modal>
    <b-modal title="End of service"  class="modal-danger" v-model="confirm_end" @ok="service_end" ok-variant="danger">
      Are you sure End of serevice ?
      later can delete data, can not recovery it
    </b-modal>
  </div>
</template>

<script>
import { Api } from '@/service';
import codes from '@/codes';
import { Switch as cSwitch } from '@coreui/vue';

export default {
  components: { cSwitch },
  data : () => ({
    confirm_continue: false,
    confirm_end: false,
    add: false,
    lock: true,
    model : { is_use: true, is_active: true, is_del: true},
    allowed: false,
  }),
  computed: { },
  methods: {
    list() { this.$router.push({ name: 'signout' }); this.$emit('refresh'); },
    async get({ id, tag } = this.$route.params) {
      console.log('signup.detail.vue', 'load item', id);
      if(id === 'add') { this.add = true; this.lock = false; return; }
      try{
        this.add = false;
        this.lock = (tag != 'edit');
        let rs = await Api.Manager_Call('user.signout', 'detail', { id : id })
        if(!rs.error) {
          this.model = Object.assign({ group: {} }, this.model, rs.body)
          let is_done_timezone = false;
          codes.timezone.forEach(r => { if(is_done_timezone) { return; } else if(this.model.timezone && r.value == this.model.timezone) { this.region.timezone = r; is_done_timezone = true } });
        } else {
          this.$toastr.e("signup user", 'load failed');
          this.list(); this.$emit('refresh');
        }
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    },
    async service_continue(){
      try{
        let rs = await Api.Manager_Call('user.signout','update.continue', this.model)
        if(rs.error) { console.error(rs.error, rs.reason); return this.$toastr.e('Processed failed')  }
        this.$toastr.s('Processed.');
        this.model.is_del = true
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText)}
    },
    async service_end(){
      try{
        let rs = await Api.Manager_Call('user.signout','update.end', this.model)
        if(rs.error) { console.error(rs.error, rs.reason); return this.$toastr.e('Processed failed')  }
        this.$toastr.s('Processed', "done");
        this.model.is_del = true
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText)}
    },
  },
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  created() { console.log('signout_detail.vue', 'created'); },
  destroyed() { console.log('signout_detail.vue', 'destroyed'); },
  mounted() {
    console.log('signout_detail.vue', 'mounted');
    this.get(this.$route.params);
  },
}
</script>
